import { getVisitorId } from '../utils/getVisitorId'

export function checkAvailabilityEvent(productId: string, sku: string, name: string, brand: string) {
    useGtm()?.trackEvent({
        event: 'checkAvailability',
        name,
        id: sku,
        productId,
        brand,
        visitorId: getVisitorId(),
    })
}
